/*
    Copyright (C) 2017 Red Hat, Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

            http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
import React, { FunctionComponent } from 'react';
import { useCanvas } from './CanvasContext';

export const CanvasTransforms: FunctionComponent = ({ children }) => {
  const { panX, panY, zoom /* width, height, xDomain, yDomain*/ } = useCanvas();
  // const originX = width / 2;
  // const originY = height / 2;
  // const x = xDomain(zoom * (panX + originX) - originX);
  // const y = yDomain(zoom * (panY + originY) - originY);

  return (
    <g
      transform={`
        translate(${panX} ${panY})
        scale(${zoom})
      `}
    >
      {children}
    </g>
  );
};
